import { HStack, IconButton, Image, Link, Stack, Text } from "@chakra-ui/react";
import React, { useState } from "react";
import { H3 } from "../Heading";
import { FiX } from "react-icons/fi";
import { telemetry } from "@/telemetry";

export const ExtraUnitsCallout = () => {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;

  const handleDismiss = () => {
    telemetry.trackEvent("extra_units_callout_dismissed");
    setIsVisible(false);
  };

  return (
    <HStack
      p="8"
      borderWidth="1px"
      borderColor="white"
      width="full"
      borderRadius="6px"
      spacing="8"
      flexDirection={{ base: "column", md: "row" }}
      position="relative"
    >
      <IconButton
        position="absolute"
        top="8"
        right="8"
        variant="ghost"
        icon={
          <FiX
            size="42"
            strokeWidth="1"
          />
        }
        aria-label={""}
        color="white"
        size="xl"
        _hover={{ bg: "transparent", color: "primary-light" }}
        onClick={handleDismiss}
      />

      <Image
        maxWidth="310px"
        src="/images/products/bundle1.jpg"
        borderRadius="6px"
      />
      <Stack
        spacing="8"
        maxWidth="620px"
        ml="auto"
      >
        <H3>Need more than 12 units for your business?</H3>
        <Text>
          Order from one of{" "}
          <Link
            color="primary-light"
            href="/docs/FINAL_orderNARCAN.ca_PP-NAR4-CA-00298_11-2025_EN_Distributor_List_v01.0.pdf"
            isExternal
            textDecoration="underline"
            onClick={() => telemetry.trackEvent("distributor_list_opened")}
          >
            Emergent’s trusted distribution partners
          </Link>{" "}
          to get access to workplace tools like wall-mounted cabinets.
        </Text>
      </Stack>
    </HStack>
  );
};
